
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "the_relationship_between_the_degree_of_hyperthyroidism_during_pregnancy_and_medication_dosage",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/the_relationship_between_the_degree_of_hyperthyroidism_during_pregnancy_and_medication_dosage.vue